var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FFF4E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#FFF4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5002H10V17.5002H9C8.86739 17.5002 8.74021 17.5529 8.64645 17.6466C8.55268 17.7404 8.5 17.8676 8.5 18.0002C8.5 18.1328 8.55268 18.26 8.64645 18.3537C8.74021 18.4475 8.86739 18.5002 9 18.5002H21C21.1326 18.5002 21.2598 18.4475 21.3536 18.3537C21.4473 18.26 21.5 18.1328 21.5 18.0002C21.5 17.8676 21.4473 17.7404 21.3536 17.6466C21.2598 17.5529 21.1326 17.5002 21 17.5002H20V13.5002H21.5C21.6088 13.5001 21.7146 13.4645 21.8013 13.3988C21.888 13.3331 21.951 13.241 21.9806 13.1363C22.0102 13.0316 22.0049 12.9201 21.9654 12.8188C21.9259 12.7174 21.8545 12.6316 21.7619 12.5746L15.2619 8.57455C15.1831 8.52613 15.0925 8.50049 15 8.50049C14.9075 8.50049 14.8169 8.52613 14.7381 8.57455L8.23812 12.5746C8.14552 12.6316 8.07406 12.7174 8.03458 12.8188C7.99511 12.9201 7.98977 13.0316 8.01939 13.1363C8.04901 13.241 8.11195 13.3331 8.19869 13.3988C8.28542 13.4645 8.39121 13.5001 8.5 13.5002ZM11 13.5002H13V17.5002H11V13.5002ZM16 13.5002V17.5002H14V13.5002H16ZM19 17.5002H17V13.5002H19V17.5002ZM15 9.58705L19.7338 12.5002H10.2662L15 9.58705ZM22.5 20.0002C22.5 20.1328 22.4473 20.26 22.3536 20.3537C22.2598 20.4475 22.1326 20.5002 22 20.5002H8C7.86739 20.5002 7.74021 20.4475 7.64645 20.3537C7.55268 20.26 7.5 20.1328 7.5 20.0002C7.5 19.8676 7.55268 19.7404 7.64645 19.6466C7.74021 19.5529 7.86739 19.5002 8 19.5002H22C22.1326 19.5002 22.2598 19.5529 22.3536 19.6466C22.4473 19.7404 22.5 19.8676 22.5 20.0002Z",
    fill: "#ED6C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/Financial.d1d026453a7287406809b069ef90ee4b.svg";
export { ForwardRef as ReactComponent };